// extracted by mini-css-extract-plugin
module.exports = {"AttachedVideo":"AttachedVideo_AttachedVideo__23XUK","WithMargin":"AttachedVideo_WithMargin__3_EWq"};